import React from "react";
import AppRemitoReactTable from "../table/AppRemitoReactTable";

import Footer from "../components/Footer";

import "../css/footer.css";

const Remitos = () => {
  return (
    <>
      <AppRemitoReactTable />
      {/* <TableRemitos /> */}
      <Footer />
    </>
  );
};

export default Remitos;
